import { actions as modalActions } from '@/bit/reducers/reducers.modals-reducer'
import { connect } from "react-redux";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`
// IMPORTS


class CmsBlock extends Component {

  constructor(props) {
    super(props);
    const { orionInfo, blockName, clientReloadNeeded } = props;
    let publishDetails = null;
    try {
      if (getPublishDetails) {
        publishDetails = getPublishDetails(orionInfo);
      }
    } catch (e) { }

    this.componentPropsRaw = JSON.parse(JSON.stringify(orionInfo[blockName]));
    this.state = {
      DetailBar: null,
      applyZoom: 0,
      editMode: false,
      publishDetails,
      componentProps: orionInfo[blockName],
      loaded: !clientReloadNeeded,
    }
  }

  componentDidUpdate(prevProps) {
    const { orionInfo, blockName } = this.props;

    if (prevProps.orionInfo !== orionInfo) {
      this.setState({
        componentProps: orionInfo[blockName],
      });
    }
  }


  // METHODS


  render() {
    const { componentProps, loaded, DetailBar, editMode, applyZoom, publishDetails } = this.state;
    const { Component, blockName, alias, modalId, addModal, blurComponent, kind } = this.props;
    // RENDER


    return (
      <Component
        {...componentProps}
        blockName={blockName}
        loaded={loaded}
        alias={alias}
      />
    )

  }
}

const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = (dispatch) => ({
  addModal: (data) => dispatch(modalActions.addModal(data))
});

CmsBlock.propTypes = {
  clientReloadNeeded: PropTypes.bool,
}

CmsBlock.defaultProps = {
  clientReloadNeeded: false,
}



export default connect(mapStateToProps, mapDispatchToProps)(CmsBlock);
